<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal">
      <div class="name">{{ name }}</div>
      <button class="close-button" @click.stop="closeModal">&times;</button>
      <div class="image-container">
        <img :src="currentImage.src" :alt="currentImage.alt"
          :style="{ transform: `rotate(${rotation}deg)`, transformOrigin: 'center center' }" />
        <div class="image-controls">
          <button @click="prevImage" :disabled="currentIndex === 0">上一张</button>
          <button @click="rotateImage">
            <img src="../assets/rotate.png" style="width:20px;height:20px;" alt="">
          </button>
          <button @click="nextImage" :disabled="currentIndex === images.length - 1">下一张</button>
        </div>
      </div>
      <div class="navigation-buttons">
        <button @click="prevImage" :disabled="currentIndex === 0">上一张</button>
        <button @click="nextImage" :disabled="currentIndex === images.length - 1">下一张</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      rotation: 0,
    }
  },
  computed: {
    currentImage () {
      return this.images[this.currentIndex]
    },
  },
  methods: {
    closeModal () {
      this.$emit('update:isVisible', false)
    },
    rotateImage () {
      this.rotation += 90
    },
    prevImage () {
      if (this.currentIndex > 0) {
        this.$emit('update:currentIndex', this.currentIndex - 1)
      }
    },
    nextImage () {
      if (this.currentIndex < this.images.length - 1) {
        this.$emit('update:currentIndex', this.currentIndex + 1)
      }
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  display: flex;
  flex-direction: column;
}
.name{
  color:#000;
  height: 30px;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  width: 80%;
  max-width: 800px;
  height: 800px;
  text-align: center;
  overflow: hidden;
  /* 防止内容溢出 */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  z-index: 100;
  padding: 5px;
}

.image-container {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  height: calc(100% - 30px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  /* 防止内容溢出 */
}

img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  transition: transform 0.3s ease;
}

.image-controls {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

button {
  margin: 5px;
  padding: 10px 20px;
  cursor: pointer;
}

.navigation-buttons {
  margin-top: 20px;
}
</style>